<template>
  <div class="visitor-data">

    <div class="data-row visitors-actions-row">
      <visitor-action-menu
        :visitor='visitor'
        :cfg-menu-visitor='cfgMenuVisitor'
        @change-visitor-access="$emit('change-visitor-access', visitor)"
        @issue-pass="$emit('issue-pass', visitor)"
        @give-pdf-pass="(isGivePassPeriod, printPermanentAsOne) => $emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne, visitor)"
      />
    </div>

    <div class="data-row visitor-center-row visitor-indicators-row">

      <div class="visitor-indicator">

        <div class='visitor-indicator-indicator'></div>

        <div>Федерал. розыск</div>

      </div>

      <div class="visitor-indicator">

        <div class='visitor-indicator-indicator'></div>

        <div>Черный список</div>

      </div>

      <div class="visitor-indicator">

        <div :class="['visitor-indicator-indicator', visitor.access === 1 ? 'visitor-indicator-indicator-active' : '']"></div>

        <div>Доступ запрещен</div>

      </div>

    </div>

    <div class="data-row visitor-center-row">

      <div class="horizontal-field">

        <div class="field-label">
          {{ fieldTitle(VisitorSectionFieldAliases.NATIONALITY) }}:
        </div>

        <div class='data-row visitor-nationality-flag-row-gap'>
          <img :src="visitorFlag" alt="" class='visitor-nationality-flag'>
          {{ visitor.personal.nationality.full_name }}
        </div>

      </div>

    </div>

    <div class="data-row visitor-center-row">

      <div class="horizontal-field">

        <div class="field-label">
          {{ fieldTitle(VisitorSectionFieldAliases.IDENTIFICATION_DOCUMENT) }}:
        </div>

        <div>{{ visitor.personal.identificationName }}</div>

      </div>

    </div>

    <div class="visitor-document-number">

      <div class="horizontal-field">

        <div class='field-label'>Серия:</div>

        <div>{{ visitor.personal.nationality_id === 182 && visitor.personal.identification_id === 'pasport' ? visitor.personal.identification_number.slice(0,4) : '' }}</div>

      </div>

      <div class="horizontal-field">

        <div class='field-label'>Номер:</div>

        <div>{{ visitor.personal.nationality_id === 182 && visitor.personal.identification_id === 'pasport' ? visitor.personal.identification_number.slice(4) : visitor.personal.identification_number }}</div>

      </div>

    </div>

    <div class="data-row visitor-center-row">

      <div class='vertical-field visitor-center-field'>

        <div class='field-label'>
          {{ fieldTitle(VisitorSectionFieldAliases.IDENTIFICATION_PLACE) }}:
        </div>

        <div>{{ visitor.personal.identification_place }}</div>

      </div>

    </div>

    <div class="data-row visitor-center-row visitor-issue-data-gap">

      <div class="horizontal-field">

        <div class='field-label'>
          {{ fieldTitle(VisitorSectionFieldAliases.IDENTIFICATION_DATE_OF) }}:
        </div>

        <div>{{ visitor.personal.identification_date_of }}</div>

      </div>

      <div class="horizontal-field">

        <div class='field-label'>
          {{ fieldTitle(VisitorSectionFieldAliases.IDENTIFICATION_CODE) }}:
        </div>

        <div>{{ visitor.personal.identification_code }}</div>

      </div>

    </div>

    <div class="visitor-main-data">

      <img :src="visitor.personal.avatar" alt="" class='visitor-avatar'>

      <div class="col visitor-fio-gap">

        <div class="horizontal-field">

          <div class='field-label'>Фамилия:</div>

          <div>{{ visitor.personal.fullname_last }}</div>

        </div>

        <div class="horizontal-field">

          <div class='field-label'>Имя:</div>

          <div>{{ visitor.personal.fullname_first }}</div>

        </div>

        <div class="horizontal-field">

          <div class='field-label'>Отчество:</div>

          <div>{{ visitor.personal.fullname_patronymic }}</div>

        </div>

        <div class="horizontal-field">

          <div class='field-label'>
            {{ fieldTitle(VisitorSectionFieldAliases.BIRTHDAY) }}:
          </div>

          <div>{{ visitor.personal.birthday }}</div>

        </div>

      </div>

    </div>

    <div class="data-row visitor-center-row">

      <div class="vertical-field visitor-center-field">

        <div class='field-label'>
          {{ fieldTitle(VisitorSectionFieldAliases.PLACEBIRTH) }}:
        </div>

        <div>{{ visitor.personal.placebirth }}</div>

      </div>

    </div>

    <div class="horizontal-field">

      <div class="field-label">
        {{ fieldTitle(VisitorSectionFieldAliases.ADDRESS) }}:
      </div>

      <div>
        {{ visitor.personal.address }}
      </div>

    </div>

    <div class="horizontal-field">

      <div class="field-label">
        {{ fieldTitle(VisitorSectionFieldAliases.ORGANIZATION_NAME) }}:
      </div>

      <div class='hide-extra-text' :title='visitor.personal.organization_name'>
        {{ visitor.personal.organization_name }}
      </div>

    </div>

    <div class="horizontal-field">

      <div class="field-label">
        {{ fieldTitle(VisitorSectionFieldAliases.ORGANIZATION_POSITION) }}:
      </div>

      <div class='hide-extra-text' :title='visitor.personal.status'>
        {{ visitor.personal.status }}
      </div>

    </div>

  </div>
</template>

<script>
import applicationViewMixin from '../../../mixins/application-view/applicationViewMixin';
import { VisitorSectionFieldAliases } from '../../../enums/ApplicationSectionFieldAliases';
import VisitorActionMenu from './menu/VisitorActionMenu.vue';
export default {
  mixins: [applicationViewMixin],
  components: { VisitorActionMenu },
  props: {
    baseUrl: {
      type: String,
      required: true
    },

    visitor: {
      type: Object
    },

    cfgFormFields: {
      type: Object,
      required: true
    },

    cfgMenuVisitor: {
      type: Object,
      required: true
    }
  },

  computed: {
    VisitorSectionFieldAliases() {
      return VisitorSectionFieldAliases
    },

    visitorFlag() {
      return `${this.baseUrl}/img/icons/${this.visitor.personal.nationality.iso2}.svg`
    }
  }
}
</script>

<style>
.visitor-data{
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.visitor-main-data{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.visitor-avatar {
  min-height: 100px;
  width: 80px;
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.02);
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.visitor-nationality-flag-row-gap, .visitor-fio-gap {
  gap: 4px;
}

.visitor-nationality-flag {
  width: 20px;
}

.visitor-document-number {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.visitor-indicators-row, .visitor-issue-data-gap {
  gap: 16px;
}

.visitor-indicators-row{
  margin-bottom: 16px;
}

.visitor-indicator {
  width: 140px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.visitor-indicator-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
}

.visitor-indicator-indicator-active {
  background-color: red;
}

.visitor-center-field {
  align-items: center;
}

.visitor-center-row {
  justify-content: center;
}

.visitors-actions-row {
  justify-content: end;
}
</style>
